module.exports = __webpack_public_path__ + "static/media/nisa.373d3a12.png";